var map = {
	"./addliquidity.json": 1168,
	"./box.json": 1169,
	"./components.json": 1170,
	"./constants.json": 1171,
	"./error.json": 1172,
	"./farm.json": 1173,
	"./home.json": 1174,
	"./launchpad.json": 1175,
	"./menu.json": 1176,
	"./minning.json": 1177,
	"./nft.json": 1178,
	"./pool.json": 1179,
	"./referral.json": 1180,
	"./removeliquidity.json": 1181,
	"./rolling.json": 1182,
	"./swap.json": 1183,
	"./team.json": 1184,
	"./uikit.json": 1185
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1167;